import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchDeviants from '@wix/da-ds/pkg/Icons/24x24/SearchDeviants';
import s from './EmptyView.scss';
const EmptyView = ()=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(SearchDeviants, {
        disableDefaultColors: true,
        className: s['icon']
    }), /*#__PURE__*/ React.createElement("div", null, t('popup.giftExclusive.emptyState.noResults', {
        postProcess: [
            'reactPostprocessor'
        ],
        br: /*#__PURE__*/ React.createElement("br", null)
    })));
};
EmptyView.displayName = 'EmptyView';
export default EmptyView;
